export const newNotificationCloseTimeout = 6000;
export const notificationChannel = '/topic/doctor';
